import { Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute'
import Dashboard from '../pages/Dashboard'
import AgentDashboard from '../pages/AgentDashboard'
import Home from '../pages/Home'
import Login from '../pages/Login'
import Register from '../pages/Register'
import Applications from '../pages/Applications'
import ApplicationDetails from '../pages/ApplicationDetails'
import Tasks from '../pages/Tasks'
import Settings from '../pages/Settings'
import PendingApproval from '../pages/PendingApproval'
import RoleValidation from '../pages/RoleValidation'
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ResetPassword'
import UserProfile from '../pages/UserProfile'
import StudentDashboard from '../pages/StudentDashboard'
import UniversityDiscovery from '../pages/UniversityDiscovery'
import StudentApplications from '../pages/StudentApplications'
import Analytics from '../pages/Analytics'

import StudentDocumentDetails from '../pages/StudentDocumentDetails'
import StudentVisa from '../pages/StudentVisa'
import StudentMessages from '../pages/StudentMessages'
import AIEngine from '../pages/AIEngine'
import AiInsights from '../pages/AiInsights'
import { useAuth } from '../contexts/AuthContext'
import { isAgent, isStudent } from '../utils/roleUtils'

import CompleteProfile from '../pages/CompleteProfile'

export default function AppRoutes() {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<Home />} />

            {/* Protected Routes */}
            <Route
                path="/role-validation"
                element={
                    <ProtectedRoute>
                        <RoleValidation />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/complete-profile"
                element={
                    <ProtectedRoute requiredRole="USER">
                        <CompleteProfile />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/pending-approval"
                element={
                    <ProtectedRoute>
                        <PendingApproval />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <DashboardRouter />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/applications"
                element={
                    <ProtectedRoute>
                        <ApplicationsRouter />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/applications/:id"
                element={
                    <ProtectedRoute requiredRole="AGENT_OR_STAFF">
                        <ApplicationDetails />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/tasks"
                element={
                    <ProtectedRoute requiredRole="AGENT_OR_STAFF">
                        <Tasks />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/analytics"
                element={
                    <ProtectedRoute requiredRole="STAFF">
                        <Analytics />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/ai-insights"
                element={
                    <ProtectedRoute requiredRole="STAFF">
                        <AiInsights />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/ai-engine"
                element={
                    <ProtectedRoute requiredRole="AGENT_OR_STAFF">
                        <AIEngine />
                    </ProtectedRoute>
                }
            />

            {/* Student Specific Routes */}
            <Route
                path="/discover"
                element={
                    <ProtectedRoute requiredRole="USER">
                        <UniversityDiscovery />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/document-upload/:appId/:documentType"
                element={
                    <ProtectedRoute requiredRole="USER">
                        <StudentDocumentDetails />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/visa"
                element={
                    <ProtectedRoute requiredRole="USER">
                        <StudentVisa />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/messages"
                element={
                    <ProtectedRoute requiredRole="USER">
                        <StudentMessages />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/settings"
                element={
                    <ProtectedRoute requiredRole="ADMIN">
                        <Settings />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/profile/:id"
                element={
                    <ProtectedRoute>
                        <UserProfile />
                    </ProtectedRoute>
                }
            />
        </Routes>
    )
}

function DashboardRouter() {
    const { user } = useAuth()
    
    if (isAgent(user)) {
        return <AgentDashboard />
    }
    
    if (isStudent(user)) {
        return <StudentDashboard />
    }
    
    return <Dashboard />
}

function ApplicationsRouter() {
    const { user } = useAuth()
    
    if (isStudent(user)) {
        return <StudentApplications />
    }
    
    return <Applications />
}
